import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { useSelector } from 'react-redux';

import { trackEscrowLabelClick, trackReliableLabelClick, trackReliableLabelHover } from './tracking';
import {
  LabelsLayout,
  BuilderStatus,
  ReliableLabelTooltip,
  EscrowLabel,
  EscrowLabelTooltip,
  DiscountMortgageTooltip,
} from '../../components/Labels';
import {
  isReliableSelector,
  getNewbuildingId,
  isEscrowSelector,
  getDiscountMortgage,
} from '../../selectors/newbuilding';
import { newbuildingLabelsSelector } from '../../selectors/newbuilding/newbuildingLabels';

export function LabelsContainer() {
  const hasDiscountMortgage = useSelector(getDiscountMortgage);
  const isReliable = useSelector(isReliableSelector);
  const isEscrow = useSelector(isEscrowSelector);
  const labels = useSelector(newbuildingLabelsSelector);
  const newbuildingId = useSelector(getNewbuildingId);

  const onReliableLabelHover = React.useCallback(() => {
    trackReliableLabelHover(newbuildingId);
  }, [newbuildingId]);

  const onReliableLabelClick = (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#reliable',
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackReliableLabelClick();
  };

  const onEscrowLabelClick = (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#escrow',
      offset: 100,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackEscrowLabelClick();
  };

  return (
    <LabelsLayout>
      {hasDiscountMortgage && <DiscountMortgageTooltip />}
      {isReliable && <ReliableLabelTooltip onOpen={onReliableLabelHover} onClick={onReliableLabelClick} />}
      {labels.labelText && <BuilderStatus {...labels} />}
      {isEscrow && <EscrowLabelTooltip label={<EscrowLabel onClick={onEscrowLabelClick} />} />}
    </LabelsLayout>
  );
}
